module.exports = function anonymous(it
) {
var out='<li class="log-entry rounded-corners-5px"> <div class="log-header light-color-entry"> <span>'+(it.msg)+'</span> </div></li>';return out;
}